// extracted by mini-css-extract-plugin
export default {"cls1":"nuNdM4v25knpBcFG1MFe","cls2":"EgA5LdKOB03l5Dy921jA nuNdM4v25knpBcFG1MFe","isPhone":"_zl4QAEaOilfHv3frIGt","submitting":"QIhMSoOV6pc3tKNedt89"};